import { render } from "./MainMarketplace.vue?vue&type=template&id=1e4f42d8&scoped=true"
import script from "./MainMarketplace.vue?vue&type=script&lang=js"
export * from "./MainMarketplace.vue?vue&type=script&lang=js"

import "./MainMarketplace.vue?vue&type=style&index=0&id=1e4f42d8&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../../../../Users/jamarrucho/Documents/2024/04_Unit/Dev/unit-org_2025_10_24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e4f42d8"]])

export default __exports__